/* @ngInject */
function toastService ($document, $translate, $timeout) {
  let toastRef = null

  return {
    closeCurrentToast,
    showSuccessToast,
    showInfoToast,
    showErrorToast,
    defaultSuccessToast,
    defaultErrorToast
  }

  // ----------------------------------------------------

  function defaultSuccessToast () {
    _createToastNode('success', $translate.instant('successTitle'))
  }

  function defaultErrorToast () {
    _createToastNode('error', $translate.instant('somethingWentWrongTryAgainMsg'))
  }

  function showSuccessToast (label) {
    _createToastNode('success', label)
  }

  function showInfoToast (label) {
    _createToastNode('info', label)
  }

  function showErrorToast (label) {
    _createToastNode('error', label)
  }

  function _createToastNode (type, label) {
    closeCurrentToast()

    toastRef = angular.element(`<uds-toast type="${type}" label="${label}" show="true"></uds-toast>`)[0]
    toastRef.addEventListener('udsclose', _handleUdsClose)

    $document.find('body').append(toastRef)
  }

  function _handleUdsClose () {
    $timeout(closeCurrentToast, 250, false)
  }

  function closeCurrentToast () {
    if (toastRef) {
      toastRef.remove()
      toastRef.removeEventListener('udsclose', _handleUdsClose)
    }
  }
}

export { toastService }
